import { Button } from "@chakra-ui/button";
import { useColorMode } from "@chakra-ui/color-mode";
import { Image } from "@chakra-ui/image";
import { Stack, Circle, Flex, Box, Text } from "@chakra-ui/layout";
import { useMediaQuery } from "@chakra-ui/media-query";
import React from "react";

function Header() {
  const { colorMode } = useColorMode();
  const isDark = colorMode === "dark";

  const [isNotSmallerScreen] = useMediaQuery("(min-width:600px)");

  return (
    <Stack>
      <Circle
        position="absolute"
        bg="blue.100"
        opacity="0.1"
        w="300px"
        h="300px"
        alignSelf="flex-end"
      />
      <Flex
        direction={isNotSmallerScreen ? "row" : "column"}
        spacing="200px"
        p={isNotSmallerScreen ? "32" : "0"}
        alignSelf="flex-start"
      >
        <Box mt={isNotSmallerScreen ? "0" : 16} align="flex-start">
          <Text fontSize="2xl" fontWeight="semibold">
            Gestures Speak, We Write
          </Text>
          <Text
            fontSize="7xl"
            fontWeight="bold"
            bgGradient="linear(to-r, cyan.400, blue.500, purple.600)"
            bgClip="text"
          >
            Gesture 2 Text
          </Text>
          <Text fontSize="xl" color={isDark ? "gray.200" : "gray.500"}>
            Translating the language of gestures into written text, enabling
            seamless communication for diverse individuals who rely on
            non-verbal expression. 🗣
          </Text>
          <Button mt={8} colorScheme="blue" onClick={() => window.open("/")}>
            Learn How your Gestures can Talk
          </Button>
        </Box>
        <Image
          alignSelf="center"
          mt={isNotSmallerScreen ? "0" : "12"}
          mb={isNotSmallerScreen ? "0" : "12"}
          borderRadius="full"
          backgroundColor="transparent"
          boxShadow="lg"
          boxSize="300px"
          src="https://github.com/Cyb3rGhoul/Gestrure2Text/blob/main/Picsart_23-10-05_18-44-10-948.jpg?raw=true"
        />
      </Flex>
    </Stack>
  );
}

export default Header;
